module.exports = __webpack_public_path__ + "static/img/2017122810233270.5648588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2017122810233270.jpg
// module id = MHPI
// module chunks = 0